import { baseRestApi, createTag } from '@src/utils/rtkQuery';
import type { CustomerConfiguration } from '@talos/kyoko';

export interface UpdateCustomerConfigurationParams {
  customerName: string;
  customerConfiguration: CustomerConfiguration;
}

export function getCustomerConfigurationTags(customerName: string) {
  return [createTag('CustomerConfiguration', 'LIST'), createTag('CustomerConfiguration', customerName)];
}

const customerConfigurationApi = baseRestApi.injectEndpoints({
  endpoints: builder => ({
    getCustomerConfiguration: builder.query<CustomerConfiguration | undefined, string>({
      query: customerName => ({
        method: 'GET',
        url: `/customers/${encodeURIComponent(customerName)}/configuration`,
      }),
      providesTags: (_result, _error, customerName) => getCustomerConfigurationTags(customerName),
      transformResponse: (response: CustomerConfiguration[]) => response[0],
    }),
    updateCustomerConfiguration: builder.mutation<CustomerConfiguration | undefined, UpdateCustomerConfigurationParams>(
      {
        query: ({ customerName, customerConfiguration }) => ({
          method: 'PATCH',
          url: `/customers/${encodeURIComponent(customerName)}/configuration`,
          headers: { 'Content-Type': 'application/json' },
          body: customerConfiguration,
        }),
        invalidatesTags: (_result, _error, { customerName }) => getCustomerConfigurationTags(customerName),
        transformResponse: (response: CustomerConfiguration[]) => response[0],
      }
    ),
  }),
});

export const { useGetCustomerConfigurationQuery, useUpdateCustomerConfigurationMutation } = customerConfigurationApi;
